module.exports = __webpack_public_path__ + "static/media/other-interest.de608e65.svg";